import React from 'react'
import { Helmet } from 'react-helmet-async'
import config from '#src/config'

interface CanonicalProps {
  path?: string
}

const Canonical: React.SFC<CanonicalProps> = ({ path }) => {
  return (
    <Helmet>
      <meta property="og:url" content={`${config.get('openGraph.url')}${path}`} />
      <link rel="canonical" href={`${config.get('openGraph.url')}${path}`} />
    </Helmet>
  )
}

export default Canonical
